// Only allow redirects to the same origin or explicitly allowed domains
const ALLOWED_DOMAINS = [
  'carvana.com',
  'youtube.com',
  'youtu.be',
  'google.com',
  // Add other trusted domains here
];

const FALLBACK_URL = '/';

const isAllowedHostname = (hostname, currentHostname) =>
  [...ALLOWED_DOMAINS, currentHostname].some(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
  );

const getSafeRedirectUrl = (to, currentOrigin = window.location.origin) => {
  if (!to) {
    return FALLBACK_URL;
  }

  let url;
  try {
    url = new URL(to, currentOrigin);
  } catch (error) {
    console.error('Invalid redirect URL:', error);
    return FALLBACK_URL;
  }

  const current = new URL(currentOrigin);
  const isSameOrigin = url.origin === current.origin;

  // Blocks javascript:, data:, etc. Plain http is only tolerated for the current origin (local dev).
  if (url.protocol !== 'https:' && !isSameOrigin) {
    console.warn('Redirect attempted with disallowed protocol:', url.protocol);
    return FALLBACK_URL;
  }

  if (!isAllowedHostname(url.hostname, current.hostname)) {
    console.warn('Redirect attempted to unauthorized domain:', url.hostname);
    return FALLBACK_URL;
  }

  // Return the exact URL that was validated. Never re-parse a string assembled from its parts:
  // a pathname like "//evil.com/" becomes a protocol-relative URL pointing at another host.
  return url.href;
};

export default getSafeRedirectUrl;
